import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { usePortal } from '../../contexts/PortalContext';
import { BUTTON_QUIET } from './adminStyles';

/** The archive: the same list, kept off the working dashboard. */
export function ArchivedProjects({
  onBack
}: {
  onBack: () => void;
}) {
  const {
    archivedProjects,
    openProject,
    reopenProject,
    notify
  } = usePortal();
  return <div data-id="element-484" data-mp="1kk7trn4njjrj">
      <button type="button" onClick={onBack} className="label group flex items-center gap-3 text-paper/40 transition-colors duration-150 ease-out hover:text-paper" data-id="element-485" data-mp="1kkg8zlo8z15w">
        <ArrowLeftIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:-translate-x-1" strokeWidth={1.25} data-id="element-486" data-mp="1ama5x0qpfozg" />
        Client Projects
      </button>

      <h1 className="mt-10 border-b border-ruleDark pb-8 font-display text-4xl leading-[0.95] tracking-tight sm:text-5xl" data-id="element-487" data-mp="34zjk35u73yo1">
        Archived Projects
      </h1>

      <ul className="m-0 list-none p-0" data-id="element-488" data-mp="39x1smv4awbvi">
        {archivedProjects.map(row => <li key={row.id} className="grid grid-cols-1 items-baseline gap-x-8 gap-y-4 border-b border-ruleDark py-8 sm:grid-cols-12" data-id="element-489" data-mp="2k9qewcizrwjf">
            <span className="font-display text-2xl leading-none sm:col-span-5" data-id="element-490" data-mp="2t2tna6es5j77">{row.client}</span>
            <span className="font-display text-xl text-paper/70 sm:col-span-4" data-id="element-491" data-mp="2p3chtczcsm21">{row.name}</span>
            <span className="flex flex-wrap items-center gap-4 sm:col-span-3 sm:justify-end" data-id="element-492" data-mp="21bxdxfrxhwoo">
              <button type="button" onClick={() => openProject(row.id)} className={BUTTON_QUIET} data-id="element-493" data-mp="1wedzaerbjhw7">
                Open Project
              </button>
              <button type="button" onClick={() => {
            reopenProject(row.id);
            notify(`${row.client} restored to Active Projects`);
          }} className={BUTTON_QUIET} data-id="element-494" data-mp="2abane8g1yl9e">
                Restore Project
              </button>
            </span>
          </li>)}
        {archivedProjects.length === 0 && <li className="border-b border-ruleDark py-8 font-display text-xl text-paper/40" data-id="element-495" data-mp="2jf4e0370hozj">
            Nothing archived.
          </li>}
      </ul>

      <p className="label-sm mt-8 max-w-xl leading-relaxed text-paper/30" data-id="element-496" data-mp="2ni0yy0k0xx6n">
        Nothing is deleted — deliverables, comments, approvals, version history, project information
        and the client link are all retained.
      </p>
    </div>;
}